import axios from 'axios'
import Cookies from 'js-cookie'
import router from './router'
import { useLoader } from '@/services/useLoader'
import { useError } from '@/services/useError'

// const http = axios.create({
//   baseURL: "/api",
// });
// const BASE_URL = "localhost";

const TOKEN_KEY = 'token'
// axios.defaults.baseURL = 'http://localhost/api'
//axios.defaults.baseURL = 'http://localhost:9041/api'
axios.defaults.baseURL = 'https://td003.seimu.jp/api'
// axios.defaults.baseURL = 'https://demo.seimu.jp/api'
// axios.defaults.baseURL = 'http://ec2-54-250-88-255.ap-northeast-1.compute.amazonaws.com/api'
// axios.defaults.baseURL =  process.env.VUE_APP_API_ENDPOINT  //?? 'http://localhost:9041/api'

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

axios.interceptors.request.use(
  config => {
    const token = Cookies.get(TOKEN_KEY)
    config.headers = {'Authorization' :'Bearer ' + token}
    return config
  })

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 401) {
      if (router.currentRoute.path !== '/auth') {
        const { toggleShowLoader } = useLoader()
        const { toggleShowError } = useError()
        toggleShowLoader(false)
        toggleShowError(true, 'token')
        router.push('/auth')
      }
    }
    if (error.response.status === 403) {
      //   store.commit("showError");
    }
    return Promise.reject(error)
  },
)

export default axios

// import axios from "axios";

// class Http {
//   constructor() {
//     this.instance = axios.create({
//       baseURL: location.origin,
//       timeout: 5000,
//     });
//   }

//   get({ url, params = {} }) {
//     return new Promise((resolve, reject) => {
//       this.instance
//         .get(url, {
//           params,
//         })
//         .then((result) => {
//           resolve(result);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }
// }

// export default Http;
